import ARVerificationStore from '@ar/stores/appStores/ARVerificationStore';

export default class ARAppStores {
  arVerificationStore: ARVerificationStore;

  constructor() {
    this.arVerificationStore = new ARVerificationStore();
  }
}
